"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseClassValidatorErrors = exports.createResponse = exports.Duration = exports.RESPONSE_TYPE = exports.headers = void 0;
var Buffer = require('buffer/').Buffer;
exports.headers = {
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Method': '*',
    'Access-Control-Allow-Credentials': true,
};
var RESPONSE_TYPE;
(function (RESPONSE_TYPE) {
    RESPONSE_TYPE[RESPONSE_TYPE["SUCCESS"] = 0] = "SUCCESS";
    RESPONSE_TYPE[RESPONSE_TYPE["NO_CONTENT"] = 1] = "NO_CONTENT";
    RESPONSE_TYPE[RESPONSE_TYPE["METHOD_NOT_ALLOWED"] = 2] = "METHOD_NOT_ALLOWED";
    RESPONSE_TYPE[RESPONSE_TYPE["BAD_REQUEST"] = 3] = "BAD_REQUEST";
    RESPONSE_TYPE[RESPONSE_TYPE["AUTH_FAILED"] = 4] = "AUTH_FAILED";
    RESPONSE_TYPE[RESPONSE_TYPE["PERMISSION_DENIED"] = 5] = "PERMISSION_DENIED";
    RESPONSE_TYPE[RESPONSE_TYPE["NOT_FOUND"] = 6] = "NOT_FOUND";
    RESPONSE_TYPE[RESPONSE_TYPE["INTERNAL_SERVER_ERROR"] = 7] = "INTERNAL_SERVER_ERROR";
})(RESPONSE_TYPE = exports.RESPONSE_TYPE || (exports.RESPONSE_TYPE = {}));
var getStatus = function (responseType) {
    switch (responseType) {
        case RESPONSE_TYPE.SUCCESS:
            return 200;
        case RESPONSE_TYPE.NO_CONTENT:
            return 204;
        case RESPONSE_TYPE.BAD_REQUEST:
            return 400;
        case RESPONSE_TYPE.AUTH_FAILED:
            return 401;
        case RESPONSE_TYPE.PERMISSION_DENIED:
            return 403;
        case RESPONSE_TYPE.NOT_FOUND:
            return 404;
        case RESPONSE_TYPE.METHOD_NOT_ALLOWED:
            return 405;
        case RESPONSE_TYPE.INTERNAL_SERVER_ERROR:
            return 500;
    }
};
var Duration = /** @class */ (function () {
    function Duration() {
        var _this = this;
        this._seconds = 0;
        this.getSeconds = function () {
            return _this._seconds;
        };
    }
    Duration.seconds = function (amount) {
        var d = new Duration();
        d._seconds = amount;
        return d;
    };
    Duration.minutes = function (amount) {
        var d = new Duration();
        d._seconds = amount * 60;
        return d;
    };
    Duration.hours = function (amount) {
        var d = new Duration();
        d._seconds = amount * 3600;
        return d;
    };
    Duration.days = function (amount) {
        var d = new Duration();
        d._seconds = amount * 3600 * 24;
        return d;
    };
    return Duration;
}());
exports.Duration = Duration;
var createResponse = function (response) {
    //message: response.message ? response.message : JSON.stringify(response.responseType),
    var _a;
    if (!response.transform)
        response.transform = false;
    //if(!response.transformContext) response.transform = false
    if (!response.culture)
        response.culture = 'en-US';
    var reqHeaders = __assign(__assign(__assign({}, exports.headers), (_a = {}, _a['x-rbs-errorcode'] = response.errorCode, _a['Cache-Control'] = response.cacheForDuration ? "max-age=" + response.cacheForDuration.getSeconds() : 'max-age=0', _a)), response.headers);
    if (response.transform) {
        reqHeaders['x-rbs-transform'] = response.transform;
        if (response.transformContext)
            reqHeaders['x-rbs-transform-context'] = Buffer.from(JSON.stringify(response.transformContext)).toString('base64');
    }
    reqHeaders['x-rbs-culture'] = response.culture;
    return {
        statusCode: getStatus(response.responseType),
        headers: reqHeaders,
        body: JSON.stringify({
            errors: response.errors,
            data: response.data,
        }),
    };
};
exports.createResponse = createResponse;
var parseClassValidatorErrors = function (errors) {
    var root = {
        target: {},
        property: '',
        value: '',
        children: errors,
    };
    return parseClassValidatorErrorObject('root', root);
};
exports.parseClassValidatorErrors = parseClassValidatorErrors;
var parseClassValidatorErrorObject = function (path, validationError) {
    var errStrings = [];
    if (validationError.constraints) {
        var keys = Object.keys(validationError.constraints);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            errStrings.push(path + '.' + String(validationError.constraints[k]));
        }
    }
    path = path + (validationError.property ? '.' + validationError.property : '');
    if (validationError.children && validationError.children.length > 0) {
        for (var _a = 0, _b = validationError.children; _a < _b.length; _a++) {
            var c = _b[_a];
            errStrings = __spreadArray(__spreadArray([], errStrings, true), parseClassValidatorErrorObject(path, c), true);
        }
    }
    return errStrings;
};
//# sourceMappingURL=helpers.js.map